// Iterative down-scale that avoids brutal pixel compression by
// halving toward the goal in ~0.75 steps. Pure — no fabric.
function canvasReduction(canvas: HTMLCanvasElement, widthGoal?: number, heightGoal?: number, scalar: number = 0.75): HTMLCanvasElement {
    if (
        (!widthGoal && !heightGoal) ||
        (widthGoal && canvas.width * scalar <= widthGoal) ||
        (heightGoal && canvas.height * scalar <= heightGoal)
    ) {
        return canvas;
    }
    const { height, width } = canvas;
    const finalImageCanvas = document.createElement('canvas');
    const ctx = finalImageCanvas.getContext('2d');
    finalImageCanvas.width = Math.round(width * scalar);
    finalImageCanvas.height = Math.round(height * scalar);
    ctx?.drawImage(canvas, 0, 0, width, height, 0, 0, finalImageCanvas.width, finalImageCanvas.height);
    return canvasReduction(finalImageCanvas, widthGoal, heightGoal, scalar);
}

export { canvasReduction };
